<template>
	<modal ref="modal" size="modal-lg">
		<template #title>{{action.toUpperCase()}} ANNOUNCEMENT CONTENT</template>
		<template #body>
			<div class="form-group mb-4">
				<div class="form-group">
					<label class="form-label" for="page_location">Page Location</label>
					<select v-model="form.page_location" name="page_location" class="form-select">
						<option value="home">Home</option>
						<option value="trc_couple_home">TRC Couple Home</option>
						<option value="trc_ai_circle_home">TRC AI Circle Home</option>
						<optgroup label="Recommendation">
							<option value="recommendation_boss">Boss</option>
							<option value="recommendation_sam">Sam</option>
							<option value="recommendation_reits">Reits</option>
							<option value="recommendation_mutual_fund">Mutual Fund</option>
						</optgroup>
						<optgroup label="TRC Live">
							<option value="trc_live_live_video_library">LIVE - Video Library</option>
							<option value="trc_live_video_library">Video Library</option>
							<option value="trc_live_vault">Vault</option>
						</optgroup>
						<optgroup label="Events">
							<option value="events_zoom_live">Zoom Live</option>
							<option value="events_list">Events</option>
						</optgroup>
					</select>
				</div>
			</div>

			<div class="form-group mb-4">
				<label class="form-label" for="membership_level">Add Membership Level</label>
				<div class="input-group">
					<select v-model="category_level" name="membership_level" class="form-control">
						<!-- <option value="TRC COUPLE">TRC COUPLE</option>
						<option value="TRC AI CIRCLE">TRC AI CIRCLE</option> -->
						<option value="SILVER">SILVER</option>
						<option value="GOLD">GOLD</option>
						<option value="DIAMOND">DIAMOND</option>
						<option value="PLATINUM">PLATINUM</option>
					</select>
					<span class="input-group-btn">
						<button @click="addMembership" type="button" class="btn btn-info"><i class="fa fa-plus me1"></i>Add</button>
					</span>
				</div>
			</div>
			<div class="form-group mb-4">
				<label class="form-label" for="title">Membership Level</label>
				<div class="mt-1">
					<span v-for="level in membership_levels" class="badge border me-2 text-black"
						:class="{'border-secondary':level=='SILVER','border-primary':level=='GOLD','border-warning':level=='DIAMOND','border-success':level=='PLATINUM','border-info':level=='ALL'}"
					>
						{{level}} 
						<button @click="removeMembership(level)" type="button" class="btn-block-option ms-2 text-danger">x</button>
					</span>
				</div>
			</div>
			<div class="form-floating mb-4">
				<input type="text" v-model="form.title" id="title" name="title" class="form-control" placeholder="Title" />
				<label class="form-label" for="title">Title</label>
			</div>
			<div class="form-group mb-4">
				<label class="form-label" for="description">Description</label>
				<div class="mb-2 text-muted">
					<p class="mb-1">Use this variable to customize the display</p>
					<span>[fname]</span>
					<span>[level]</span>
					<span>[expiry]</span>
				</div>
				<!-- <ckeditor v-model="form.description" :editor="editor" :config="editorConfig"></ckeditor> -->
				<textarea id="ckeditor_announce"></textarea>
			</div>
			<div class="form-floating mb-4">
				<div class="mb-4">
					<label class="form-label" for="announcement_img">Image</label>
					<input
						@change="onFileChange"
						type="file"
						id="announcement_img"
						name="announcement_img"
						class="form-control"
						:accept="[
			            'image/jpeg',
			            'image/jpg',
			            'image/png'
			          ]"
					/>
				</div>
				<div class="mb-4">
					<div v-if="form.prev_announcement_img!=null"
						class="overflow-hidden rounded text-center bg-body-light border-start border-4 border-primary"
						style="height: 300px;background-size: contain;background-repeat: no-repeat;background-position: center;"
						:class="{'opacity-25':(form.announcement_img!=form.prev_announcement_img && form.prev_announcement_img!=null && action=='update')}"
					>
						<img :src="form.announcement_img_url" style="width:100%;" />
					</div>
					<div v-if="form.announcement_img!=form.prev_announcement_img && form.prev_announcement_img!=null && action=='update'" class="text-center text-muted">
						<i class="fa fa-arrow-down fa-2x"></i>
					</div>
					<div>
						<div id="image-preview" 
						class="overflow-hidden rounded text-center bg-body-light border-start border-4 border-primary"
						style="background-size: contain;background-repeat: no-repeat;background-position: center;"
						:style="{'height':(form.announcement_img!=form.prev_announcement_img)?'300px':'0px'}">
							
						</div>
						<div v-if="form.announcement_img!=form.prev_announcement_img && form.prev_announcement_img!=null && action=='update'" class="text-center"><button @click="removeUploadImage" type="button" class="btn btn-outline-danger btn-sm"><i class="fa fa-times me-2"></i>Remove</button></div>
					</div>
				</div>
			</div>
			<div class="form-floating mb-4">
				<flat-pickr
					v-model="form.start_datetime"
					:config="{
						enableTime: true,
						altInput: true,
						altFormat: 'M j, Y h:i K',
						dateFormat: 'Y-m-d H:i:s',
					}"
					class="form-control"
					:class="
						form.errors.start_datetime
							? 'flatpickr-input is-invalid border-danger'
							: 'flatpickr-input'
					"
				/>
				<label class="form-label" for="start_datetime">Start DateTime</label>
			</div>
			<div class="form-floating mb-4">
				<flat-pickr
					v-model="form.end_datetime"
					:config="{
						enableTime: true,
						altInput: true,
						altFormat: 'M j, Y h:i K',
						dateFormat: 'Y-m-d H:i:s',
					}"
					class="form-control"
					:class="
						form.errors.end_datetime
							? 'flatpickr-input is-invalid border-danger'
							: 'flatpickr-input'
					"
				/>
				<label class="form-label" for="end_datetime">End DateTime</label>
			</div>
			<div class="form-group mb-4">
				<label class="form-label" for="is_active">Status</label>
				<div class="mt-2">
					<div class="form-check form-check-inline">
						<input
							v-model="form.is_active"
							id="is_active_on"
							name="is_active"
							class="form-check-input"
							type="radio"
							value="1"
						/>
						<label class="form-check-label bg-alt-primary" for="ON">ON</label>
					</div>
					<div class="form-check form-check-inline">
						<input
							v-model="form.is_active"
							id="is_active_off"
							name="is_active"
							class="form-check-input"
							type="radio"
							value="0"
						/>
						<label class="form-check-label bg-alt-primary" for="OFF">OFF</label>
					</div>
				</div>
			</div>
				
		</template>
		<template #footer>
			<button 
				@click="actionContent"
				type="submit"
				class="btn btn-alt-primary"
				:disabled="form.processing || !form.isDirty"
			>
				<span v-if="!form.processing"><i class="fa fa-save me-2"></i><span v-if="action=='add'">Add</span><span v-else>Update</span> Content</span>
					<span v-else>
						<div class="spinner-border spinner-border-sm text-dark" role="status" >
							<span class="sr-only mr-1">Please wait...</span>
						</div>
						<span class="mx-2">Please wait...</span>
					</span>
			</button>
			<button
				@click="toggleModal"
				type="button"
				class="btn btn-alt-secondary"
				:disabled="form.processing"
			>
				Close
			</button>
		</template>
	</modal>
</template>

<script>
import { watch, ref, reactive } from 'vue'
import { useForm } from '@inertiajs/inertia-vue3'
import CKEditorInit from './../../Shared/ckeditor-init';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
// import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
// import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';

// import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials';
// import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold';
// import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic';
// import LinkPlugin from '@ckeditor/ckeditor5-link/src/link';
// import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph';
// import SourceEditing from '@ckeditor/ckeditor5-source-editing/src';

export default {
	props: {
		
	},
	mounted(){
		// window.Codebase.helpersOnLoad(['ckeditor_announce']);
		CKEditorInit('ckeditor_announce');
	},
	setup(props) {
		const modal = ref(null);

		// const editor 		= ref(ClassicEditor);
		const editor 		= ref(null);
		const editorConfig 	= {
			                    
			                    // plugins: [
			                    //     // EssentialsPlugin,
			                    //     // BoldPlugin,
			                    //     // ItalicPlugin,
			                    //     // LinkPlugin,
			                    //     // ParagraphPlugin,
			                    //     SourceEditing
			                    // ],

			                    // // toolbar: {
			                    // //     items: [
			                    // //         // 'bold',
			                    // //         // 'italic',
			                    // //         // 'link',
			                    // //         // 'undo',
			                    // //         // 'redo',
			                    // //         'sourceEditing'
			                    // //     ]
			                    // // }
			                    // toolbar:['sourceEditing']
		                    
							};

		const category_level = ref('SILVER');

		const membership_levels = ref(['ALL']);
		
		const action = ref('add');

		const form = useForm({
			announcement_id			: 0,
			page_location 			: '',
			membership_level 		: 'ALL',
			title 					: null,
			description 			: '',
			prev_announcement_img 	: null,
			announcement_img 		: null,
			announcement_img_url 	: null,
			start_datetime 			: null,
			end_datetime 			: null,
			is_active 				: 1
		})

		const toggleModal = () => {
			
			if(action.value=='add')
			{
				// CKEDITOR.instances['ckeditor_announce'].setData('<p></p>');
				window['ckeditor_announce'].setData('<p></p>');
			}else
			{
				window['ckeditor_announce'].setData(form.description);
			}

			modal.value.toggleModal();
			
		}

		const addMembership = ()=>{
			
			if(membership_levels.value[0]=="ALL")
			{
				membership_levels.value[0] = category_level.value;
			}else
			{
				membership_levels.value.push(category_level.value);
			}

			configMembership();
		}

		const removeMembership = (_level)=>{
			membership_levels.value = membership_levels.value.filter((data)=>{
				if(_level!=data)
				{
					return data;
				}
			})

			configMembership();
		}

		const configMembership = ()=>{
			if(membership_levels.value.length==0)
			{
				membership_levels.value[0] 	= "ALL";
				form.membership_level 		= membership_levels.value[0];
			}else{
				for (var i = 0; i < membership_levels.value.length; i++) {
					var level = membership_levels.value[i];
					if(i==0)
					{
						form.membership_level = level;
					}else{
						form.membership_level += ","+level;	
					}
					
				}
			}
		}

		const clearUpload = ()=>{
			$("#image-preview").html('');
			$("#announcement_img").val('');
		}

		const onFileChange = (e) => {
			const image_preview = document.getElementById('image-preview')
			if (e.target.files.length > 0) {
				form.announcement_img = e.target.files[0]
				const src = URL.createObjectURL(e.target.files[0])
				image_preview.innerHTML = `<img src="${src}" class="img-fluid" style="height:100%;width:auto" />`;
			} else {
				form.announcement_img = null
				image_preview.innerHTML = ''
			}
		}

		const removeUploadImage = ()=>{
			form.announcement_img = form.prev_announcement_img;
			clearUpload();
		}

		const actionContent = ()=>{

			// form.description = CKEDITOR.instances['ckeditor_announce'].getData();
			form.description = window['ckeditor_announce'].getData();

			if(action.value=='add')
			{
				addContent();
			}else
			{
				updateContent();	
			}

		}

		const addContent = () => {
			form.post(route('admin.post.announcements'), {
				preserveState: true,
				preserveScroll: true,
				only:['announcements,api_response'],
				onSuccess: () => {
					form.reset();
					toggleModal();
				},
			})
		}

		const updateContent = () => {
			form.post('announcements/'+form.announcement_id, {
				preserveState: true,
				preserveScroll: true,
				only:['announcements,api_response'],
				onSuccess: () => {
					form.reset();
					toggleModal();
				},
			})
		}

		const setAnnouncementContent = (_action,data)=>{
								
								form.reset();

								action.value = _action;

								if(_action=='update')
								{
									form.announcement_id 		= data.announcement_id;
									form.page_location 			= data.page_location;
									form.membership_level 		= data.membership_level;
									form.title 					= data.title;
									form.description 			= data.description;
									form.prev_announcement_img 	= data.prev_announcement_img;
									form.announcement_img 		= data.announcement_img;
									form.announcement_img_url 	= data.announcement_img_url;
									form.start_datetime 		= data.start_datetime;
									form.end_datetime 			= data.end_datetime;
									form.is_active 				= data.is_active;

									membership_levels.value 	= data.membership_level.split(",");

								}
								
							}


		return {
			form,
			modal,
			category_level,
			membership_levels,
			// editor,
			editorConfig,
			toggleModal,
			action,
			clearUpload,
			removeUploadImage,
			onFileChange,
			setAnnouncementContent,
			addMembership,
			removeMembership,
			configMembership,
			actionContent,
			addContent,
			updateContent,
		}
	},
}
</script>

<style>
	.ck-content,.ck-source-editing-area{
		height: 300px;
	}
	
</style>